import { Link } from "gatsby";
import React, { useState } from "react";

import fabriqoLogo from "../images/fabriqo-logo.svg";
import { useSiteTitelQuery } from "../queries";

function Header() {
  const [isExpanded, toggleExpansion] = useState(false);
  const { site } = useSiteTitelQuery();

  return (
    <header className="bg-teal-600">
      <div className="flex flex-wrap items-center justify-between max-w-4xl p-4 mx-auto md:p-8">
        <Link to="/">
          <img
            alt={site.siteMetadata.title}
            className="block w-24 text-white-600"
            src={fabriqoLogo}
          />
        </Link>

        <button
          className="items-center block px-3 py-2 text-white border border-white rounded md:hidden"
          onClick={() => toggleExpansion(!isExpanded)}
        >
          <svg
            className="w-3 h-3 fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>

        <nav
          className={`${
            isExpanded ? `block` : `hidden`
          } md:block md:items-center w-full md:w-auto`}
        >
          {[
            {
              route: `/about`,
              title: `About`,
            },
            {
              route: `/contact`,
              title: `Contact`,
            },
            {
              route: `/docs`,
              title: `Docs`,
            },
            {
              route: `https://app.fabriqo.com`,
              title: `Login`,
            },
          ].map((link) => (
            <Link
              className="block mt-4 text-white no-underline md:inline-block md:mt-0 md:ml-6"
              key={link.title}
              to={link.route}
            >
              {link.title}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;
